import React, {ReactNode} from 'react';
import {Breadcrumbs} from '~/components/Breadcrumps';
import {Title} from '~/components/Title';
import style from './index.module.scss';

interface IResourcePageProps {
    children: ReactNode;
    title?: ReactNode;
    toolbar?: ReactNode;
    topRightAction?: ReactNode;
    className?: string;
}

export const BreadcrumbsResourcePage = ({className, children, title, toolbar, topRightAction}: IResourcePageProps) =>
    <div className={[style.resourcePage, className].join(' ')}>
        <div className="page-header-sticky">
            <div className={style.resourceHeader}>
                <div className="page-header-breadcrumbs">
                    <Breadcrumbs className={style.resourceBreadcrumbs}/>
                </div>
                <div className={style.flexBetween}>{topRightAction}</div>
                <Title className={`${style.resourceTitle} page-header-title`} children={title} toolbar={toolbar}/>
            </div>
        </div>
        <div className={style.resourceBody}>
            {children}
        </div>
    </div>;

export const ResourcePage = ({className, children, title, toolbar}: IResourcePageProps) =>
    <div className={[style.resourcePage, className].join(' ')}>
        <div className="page-header-sticky">
            <div className={style.resourceHeader}>
                <Title className={`${style.resourceTitle} page-header-title`} children={title} toolbar={toolbar}/>
            </div>
        </div>
        <div className={style.resourceBody}>
            {children}
        </div>
    </div>;

interface IResourceBlockProps extends React.HTMLAttributes<HTMLDivElement> {
    title?: string;
    toolbar?: ReactNode;
}

export const ResourceBlock = ({
    children,
    className,
    title,
    toolbar,
    ...props
}: IResourceBlockProps) =>
    <div {...props} className={[style.resourceBlock, className].join(' ')}>
        {(title || toolbar) && (
            <div className={style.resourceBlockHeader}>
                {title && <div className={style.resourceBlockTitle}>{title}</div>}
                {toolbar && <div className={style.resourceBlockToolbar}>{toolbar}</div>}
            </div>
        )}
        <div className={style.resourceBlockBody} children={children}/>
    </div>;
